import { GetServerSideProps } from "next";
import CourseView from "@components/views/CourseView";
import { allSettled, fork, serialize } from "effector";
import { setInstructorId } from "@components/views/Instructor/model/public";

import { $courseAuthorInfo } from "@models/courses/public";
import "@features/Course/model/init";
import { $course, getCourse } from "@features/Course/model/public";
import { getCourseAuthorInfo } from "@models/courses/getCourseAuthors";

const CoursePage = () => {
	return <CourseView isPreviewMode={false} />;
};

// TODO: Переделать на getStaticProps https://github.com/spiks/selfschool-backend/issues/281
export const getServerSideProps: GetServerSideProps = async ({ query }) => {
	try {
		if (query.courseId === undefined) {
			return {
				redirect: {
					permanent: true,
					destination: "/",
				},
			};
		}
		const courseUrl = query.courseId.toString();

		const scope = fork();

		await allSettled(getCourse, {
			scope,
			params: {
				purchased: false,
				url: courseUrl,
			},
		});

		const course = scope.getState($course);

		await allSettled(getCourseAuthorInfo, {
			scope,
			params: course?.authorId,
		});

		const author = scope.getState($courseAuthorInfo);
		// У некоторых курсов authors - пустой массив.
		await allSettled(setInstructorId, {
			scope,
			params: author?.id ?? null,
		});

		return {
			props: {
				initialState: serialize(scope),
			},
		};
	} catch (e) {
		return {
			notFound: true,
		};
	}
};

export default CoursePage;
